<template>
  <div class="modal-level2-bottom" v-if="
    firstRoute($route.path) != 'myrequest' &&
    $route.path != '/level1' &&
    $route.params.status != 13
  ">
    <div class="mr20" @click="approve()" v-if="
      $get($route, 'params.status') != 9 && $get($store, 'state.role_id') == 1
    ">
      APPROVE
    </div>
    <div class="mr20" @click="approveHead()" v-if="
      $get($route, 'params.status') == 9 && $get($store, 'state.role_id') == 2
    ">
      APPROVE HEAD
    </div>
    <div class="mr20" @click="reject()" v-if="
      $get($route, 'params.status') != 9 && $get($store, 'state.role_id') == 1
    ">
      REJECT
    </div>
    <div class="mr20" @click="reviseNow()" v-if="
      $get($route, 'params.status') != 9 && $get($store, 'state.role_id') == 1
    ">
      {{
        editingStatus == 1 || editingStatus == true
          ? `CANCEL ( ${editingUser} )`
          : 'REVISE NOW'
      }}
    </div>
    <div class="mr20" @click="needReview()" v-if="
      $get($route, 'params.status') != 9 && $get($store, 'state.role_id') == 1
    ">
      NEED REVIEW
    </div>
    <div class="mr20" @click="reviewHead()" v-if="
      $get($route, 'params.status') == 9 && $get($store, 'state.role_id') == 2
    ">
      REVIEW HEAD
    </div>
    <div class="mr20" @click="reviewFromLanding()" v-if="
      $get($route, 'params.status') != 9 && $get($store, 'state.role_id') == 1
    ">
      {{
        editingStatusLp == 1 || editingStatusLp == true
          ? `CANCEL ( ${editingUserLp} )`
          : 'REVIEW FROM LANDING PAGE'
      }}
    </div>
    <div class="mr20" @click="postpone()" v-if="
      $get($route, 'params.status') != 9 && $get($store, 'state.role_id') == 1
    ">
      POSTPONE
    </div>
  </div>
</template>
<script>
export default {
  async created() {
    await this.$store.dispatch('editingStore/getRequestStatus', {
      id: this.$route.params.id,
      name: 'validation_revise',
    })

    await this.$store.dispatch('editingStore/getRequestStatus', {
      id: this.$route.params.id,
      name: 'review_from_landingpage',
    })
  },
  computed: {
    editingStatus() {
      return this.$get(
        this.$store,
        'state.editingStore.validation_revise.is_open',
        0
      )
    },
    editingUser() {
      return this.$get(
        this.$store,
        'state.editingStore.validation_revise.open_by',
        ''
      )
    },
    editingId() {
      return this.$get(
        this.$store,
        'state.editingStore.validation_revise.id',
        ''
      )
    },
    editingStatusLp() {
      return this.$get(
        this.$store,
        'state.editingStore.review_from_landingpage.is_open',
        0
      )
    },
    editingUserLp() {
      return this.$get(
        this.$store,
        'state.editingStore.review_from_landingpage.open_by',
        ''
      )
    },
    editingIdLp() {
      return this.$get(
        this.$store,
        'state.editingStore.review_from_landingpage.id',
        ''
      )
    },
  },
  methods: {
    async approve() {
      this.$store.dispatch('approvalSheet/approveVendor', {
        id: this.$store.state.approvalSheet.request_id,
      })
    },
    async reject() {
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: 'modalReview',
        value: true,
      })
      this.$store.commit('approvalSheet/SET_DATA', {
        name: 'reviewState',
        value: 2,
      })
    },
    approveHead() {
      this.$store.dispatch('approvalSheet/approveHead', {
        id: this.$store.state.approvalSheet.request_id,
      })
    },
    reviewHead() {
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: 'modalReview',
        value: true,
      })
      this.$store.commit('approvalSheet/SET_DATA', {
        name: 'reviewState',
        value: 1,
      })
    },
    reviseNow() {
      if (this.editingStatus == 1 || this.editingStatus == true) {
        this.$store.dispatch('editingStore/deleteEditingStatus', {
          id: this.editingId,
          is_open: 0,
          open_by: this.$store.state.currentUser,
          user_id: this.$store.state.userid,
          request_id: this.$store.state.approvalSheet.request_id,
          name: 'validation_revise',
        })
      } else {
        this.$store.dispatch('editingStore/addEditingStatus', {
          is_open: 1,
          desc: 'validation_revise',
          open_by: this.$store.state.currentUser,
          user_id: this.$store.state.userid,
          request_id: this.$store.state.approvalSheet.request_id,
          name: 'validation_revise',
          onSuccess: () => { },
        })
      }
      // this.$store.commit('editStore/SET_EDIT_VALIDATION')

      // this.$router.push(
      //   `/revise-now/${this.$store.state.approvalSheet.request_id}/${this.$store.state.userid}`
      // )
    },
    reviewFromLanding() {
      if (this.editingStatusLp == 1 || this.editingStatusLp == true) {
        this.$store.dispatch('editingStore/deleteEditingStatus', {
          id: this.editingIdLp,
          is_open: 0,
          open_by: this.$store.state.currentUser,
          user_id: this.$store.state.userid,
          request_id: this.$store.state.approvalSheet.request_id,
          name: 'review_from_landingpage',
        })
      } else {
        this.$store.dispatch('editingStore/addEditingStatus', {
          is_open: 1,
          desc: 'review_from_landingpage',
          open_by: this.$store.state.currentUser,
          user_id: this.$store.state.userid,
          request_id: this.$store.state.approvalSheet.request_id,
          name: 'review_from_landingpage',
          onSuccess: () => {
            let routeData = this.$router.resolve({
              path: `/review-from-landing-page/${this.$store.state.approvalSheet.request_id}/${this.$store.state.userid}`,
            })

            window.open(routeData.href, '_blank')
          },
        })
      }
    },
    needReview() {
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: 'modalReview',
        value: true,
      })
      this.$store.commit('approvalSheet/SET_DATA', {
        name: 'reviewState',
        value: 3,
      })
    },
    postpone() {
      this.$store.dispatch('approvalSheet/postpone', {
        id: this.$store.state.approvalSheet.request_id,
      })
    },
    async extendToSap() {
      if (this.$get(this.$store, 'state.permissions.66.allow')) {
        await this.$store.dispatch(
          'myRequest/sapDetail',
          this.$store.state.level1.profile.id
        )
        await this.$store.commit('modalReqApp/SET_VALUE', {
          name: 'modalExtendSap',
          value: true,
        })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    blockVendor() {
      if (this.$get(this.$store, 'state.permissions.67.allow')) {
        this.$store.dispatch(
          'myRequest/sapDetail',
          this.$store.state.level1.profile.id
        )
        this.$store.commit('modalReqApp/SET_VALUE', {
          name: 'modalBlockVendor',
          value: true,
        })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    unblockVendor() {
      if (this.$get(this.$store, 'state.permissions.68.allow')) {
        this.$store.dispatch(
          'myRequest/sapDetail',
          this.$store.state.level1.profile.id
        )
        this.$store.commit('modalReqApp/SET_VALUE', {
          name: 'modalUnblockVendor',
          value: true,
        })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    deleteVendor() {
      this.$store.commit('SET_NOTIF', 'Maaf, Fitur sedang dalam pengembangan.')
    },
    changeLogo() {
      this.$store.commit('SET_NOTIF', 'Maaf, Fitur sedang dalam pengembangan.')
    },
  },
}
</script>
